import React, { FC } from 'react';
import classNames from 'classnames';

type Props = {
  noMobile: boolean;
};

export const NavButtonize: FC<Props> = ({ children, noMobile = false }) => (
  <div
    className={classNames('button clear nav__button', {
      nav__button_no_mobile: noMobile,
      nav__button: !noMobile,
    })}
  >
    {children}
  </div>
);
